module.exports = __webpack_public_path__ + "30f88b81be59b6527917724bffbc8d7f.svg";